import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import { AuthReducers } from "./redux/Reducer/AuthReducer";
import { CompanyReducer } from "./redux/Reducer/ProfileReducer";
import { CmsReducers } from "./redux/Reducer/CmsPageReducer";
import { DashboardReducers } from "./redux/Reducer/DashboardReducer";
import { StaffMemberReducers } from "./redux/Reducer/StaffMemberReducer";
import { MyProfileReducers } from "./redux/Reducer/MyProfileReducer";
import { SalonAvailabilityReducers } from "./redux/Reducer/AvailabilityReducer";
import { BillingManagementReducer } from "./redux/Reducer/BillingReducer";
import { NotificationReducers } from "./redux/Reducer/NotificationReducer";
import { SalesGrowthReducers } from "./redux/Reducer/SalesGrowthReducer";

const reducer = combineReducers({
  ...AuthReducers,
  ...CompanyReducer,
  ...CmsReducers,
  ...DashboardReducers,
  ...StaffMemberReducers,
  ...MyProfileReducers,
  ...SalonAvailabilityReducers,
  ...BillingManagementReducer,
  ...NotificationReducers,
  ...SalesGrowthReducers
})

let initialState = {}
const middleware = [thunk]
const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)))
export default store;
